import React from "react";
import * as cl from "./MainInfo.module.scss";
import LockedContent from "../LockedContent";
import Enroll from "../Enroll";
import CourseItem from "../CourseItem";

const MainInfo = ({
  state,
  meta: { title, has_access, access, upgrade_url },
  name,
  locked,
  enroll,
  changeSelect,
  onNoAccessClick,
  onEnroll,
  video_length,
}) => {
  return (
    <div className={cl.wrapper}>
      <h1 className={cl.title} dangerouslySetInnerHTML={{ __html: title }} />
      <h1
        className={cl.title}
        dangerouslySetInnerHTML={{ __html: video_length }}
      />

      {locked && !enroll ? (
        <LockedContent link={upgrade_url} />
      ) : (
        <>
          {enroll && (
            <Enroll
              name={name}
              hasAccess={has_access}
              access={access}
              locked={locked}
              onEnroll={onEnroll}
              onNoAccessClick={onNoAccessClick}
            />
          )}

          <div className={cl.lessons}>
            <h2 className={cl.lessons__title}>Course Content</h2>
            <ul className={cl.lessons_list}>
              {state.map((item) => {
                return (
                  <li className={cl.lessons__lesson} key={item.id} onClick={() => changeSelect(title)}>
                    <CourseItem item={item} onNoAccessClick={onNoAccessClick} />
                  </li>
                );
              })}
            </ul>
          </div>
        </>
      )}
    </div>
  );
};

export default MainInfo;
